import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.calendar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-calendar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.calendar/view.scss */
/* src/app/page.calendar/view.scss: no such file or directory */`],
})
export class PageCalendarComponent implements OnInit {
    public rooms: any[] = [];
    public members: any[] = [];
    public events: any[] = [];
    public calendarDays: any[] = [];
    public weekDays: string[] = ['일', '월', '화', '수', '목', '금', '토'];
    public timeOptions: string[] = [
        '09:00', '09:30', '10:00', '10:30',
        '11:00', '11:30', '12:00', '12:30',
        '13:00', '13:30', '14:00', '14:30',
        '15:00', '15:30', '16:00', '16:30',
        '17:00', '17:30', '18:00'
    ];
    public selectedRoom: string = 'all';
    public selectedDate: string = '';
    public currentYear: number = 2026;
    public currentMonth: number = 6;
    public summary: string = '이번 달 예약 8건';
    public loading: boolean = true;

    public showDetailModal: boolean = false;
    public activeEvent: any = null;
    public showAddModal: boolean = false;
    public showScheduleList: boolean = false;
    public scheduleForm: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.setDefaults();
        this.buildCalendar();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const response: any = await wiz.call("schedule");
        const { code, data } = response;
        if (code === 200 && data) {
            this.rooms = this.withRoomStyles(data.rooms || this.rooms);
            this.members = data.members || this.members;
            this.events = data.events || this.events;
            this.summary = data.summary || this.summary;
            this.currentYear = data.year || this.currentYear;
            this.currentMonth = data.month || this.currentMonth;
        }

        this.ensureOrganizerMember();
        this.sortEvents();
        this.ensureSelectedDateInMonth();
        this.buildCalendar();
        this.loading = false;
        await this.service.render();
    }

    public async previousMonth() {
        if (this.currentMonth === 1) {
            this.currentYear -= 1;
            this.currentMonth = 12;
        } else {
            this.currentMonth -= 1;
        }
        this.ensureSelectedDateInMonth();
        this.buildCalendar();
        await this.service.render();
    }

    public async nextMonth() {
        if (this.currentMonth === 12) {
            this.currentYear += 1;
            this.currentMonth = 1;
        } else {
            this.currentMonth += 1;
        }
        this.ensureSelectedDateInMonth();
        this.buildCalendar();
        await this.service.render();
    }

    public async goToday() {
        const today = new Date();
        this.currentYear = today.getFullYear();
        this.currentMonth = today.getMonth() + 1;
        this.selectedDate = this.toDateKey(today);
        this.buildCalendar();
        await this.service.render();
    }

    public async selectRoom(roomId: string) {
        this.selectedRoom = roomId;
        this.buildCalendar();
        await this.service.render();
    }

    public async selectDate(dateKey: string) {
        this.selectedDate = dateKey;
        this.showScheduleList = true;
        const date = this.parseDateKey(dateKey);
        this.currentYear = date.getFullYear();
        this.currentMonth = date.getMonth() + 1;
        this.buildCalendar();
        await this.service.render();
    }

    public async closeScheduleList() {
        this.showScheduleList = false;
        this.selectedDate = '';
        this.buildCalendar();
        await this.service.render();
    }

    public selectedDateEvents() {
        if (!this.selectedDate) return [];
        return this.eventsForDate(this.selectedDate);
    }

    public monthEventCount() {
        return this.events.filter((event: any) => {
            return event.date && event.date.startsWith(this.monthPrefix()) && this.matchesSelectedRoom(event);
        }).length;
    }

    public monthLabel() {
        return `${this.currentYear}년 ${this.currentMonth}월`;
    }

    public selectedDateLabel() {
        if (!this.selectedDate) return '';
        const date = this.parseDateKey(this.selectedDate);
        return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 (${this.weekDays[date.getDay()]})`;
    }

    public roomName(roomId: string) {
        const room = this.rooms.find((item: any) => item.id === roomId);
        return room ? room.name : '';
    }

    public roomClass(roomId: string, key: string) {
        const room = this.rooms.find((item: any) => item.id === roomId);
        if (room && room[key]) return room[key];
        if (key === 'dotClass') return 'bg-gray-400';
        if (key === 'eventClass') return 'border-l-gray-400 bg-gray-50 text-gray-800 hover:bg-gray-100';
        if (key === 'chipClass') return 'border-gray-200 bg-gray-100 text-gray-700';
        return 'bg-gray-100 text-gray-700';
    }

    public eventTime(event: any) {
        if (event.time) return event.time;
        return `${event.start}-${event.end}`;
    }

    public organizerLabel() {
        const user = this.currentUser();
        if (user.email) return `${user.name} (${user.email})`;
        return user.name;
    }

    public attendeeLabel(attendee: any) {
        if (!attendee) return '';
        if (typeof attendee === 'string') return attendee;
        if (attendee.email) return `${attendee.name} (${attendee.email})`;
        return attendee.name || '';
    }

    public externalAttendeeLabel(attendee: any) {
        if (!attendee) return '';
        if (typeof attendee === 'string') return attendee;
        if (attendee.email) return `${attendee.name} / ${attendee.email}`;
        return attendee.name || '';
    }

    public externalProjectLabel(event: any) {
        if (!event) return '';
        if (event.externalProjectName) return event.externalProjectName;
        const attendee = (event.externalAttendees || [])[0];
        return attendee && attendee.projectName ? attendee.projectName : '';
    }

    public internalAttendeeOptions() {
        const selectedIds = (this.scheduleForm.attendees || []).map((attendee: any) => String(attendee.id));
        const organizerId = String(this.currentUser().id || '');
        return this.members.filter((member: any) => {
            return member.id
                && String(member.id) !== organizerId
                && selectedIds.indexOf(String(member.id)) === -1;
        });
    }

    public async openEvent(event: any, domEvent?: Event) {
        if (domEvent) domEvent.stopPropagation();
        this.activeEvent = event;
        this.showDetailModal = true;
        await this.service.render();
    }

    public async closeDetail() {
        this.showDetailModal = false;
        this.activeEvent = null;
        await this.service.render();
    }

    public async openAdd(dateKey?: string, domEvent?: Event) {
        if (domEvent) domEvent.stopPropagation();
        const targetDate = dateKey || this.selectedDate || this.toDateKey(new Date());
        const defaultRoomId = this.selectedRoom !== 'all'
            ? this.selectedRoom
            : this.rooms.length > 0 ? this.rooms[0].id : '';

        this.scheduleForm = {
            title: '',
            date: targetDate,
            roomId: defaultRoomId,
            start: '09:00',
            end: '10:00',
            organizer: this.organizerLabel(),
            organizerUser: this.currentUser(),
            selectedMemberId: '',
            attendees: [],
            externalProjectName: '',
            externalDraft: {
                name: '',
                email: ''
            },
            externalAttendees: [],
            memo: ''
        };
        this.normalizeScheduleTime();
        this.showAddModal = true;
        await this.service.render();
    }

    public async closeAdd() {
        this.showAddModal = false;
        await this.service.render();
    }

    public async addInternalAttendee(render: boolean = true) {
        const memberId = this.scheduleForm.selectedMemberId;
        if (!memberId) return true;

        const member = this.members.find((item: any) => String(item.id) === String(memberId));
        if (!member) return true;

        const exists = (this.scheduleForm.attendees || []).some((attendee: any) => {
            return String(attendee.id) === String(member.id);
        });
        if (!exists) {
            this.scheduleForm.attendees.push({
                id: member.id,
                name: member.name,
                email: member.email,
                role: member.role
            });
        }

        this.scheduleForm.selectedMemberId = '';
        if (render) await this.service.render();
        return true;
    }

    public async removeInternalAttendee(attendee: any) {
        this.scheduleForm.attendees = (this.scheduleForm.attendees || []).filter((item: any) => {
            return String(item.id) !== String(attendee.id);
        });
        await this.service.render();
    }

    public async addExternalAttendee(focusTargetOrRender: any = true, render: boolean = true) {
        let focusTarget = focusTargetOrRender;
        if (typeof focusTargetOrRender === 'boolean') {
            render = focusTargetOrRender;
            focusTarget = render ? 'external-attendee-name' : null;
        }

        const projectName = (this.scheduleForm.externalProjectName || '').trim();
        const name = (this.scheduleForm.externalDraft?.name || '').trim();
        const email = (this.scheduleForm.externalDraft?.email || '').trim();

        if (!name && !email) return true;

        if (!projectName) {
            await this.service.modal.error('외부 참석자 프로젝트명을 입력해주세요.');
            return false;
        }

        if (!name) {
            await this.service.modal.error('외부 참석자 이름을 입력해주세요.');
            return false;
        }

        if (email && !this.isEmail(email)) {
            await this.service.modal.error('외부 참석자 이메일 형식을 확인해주세요.');
            return false;
        }

        this.scheduleForm.externalAttendees.push({
            projectName,
            name,
            email
        });
        this.scheduleForm.externalDraft = {
            name: '',
            email: ''
        };

        if (render) await this.service.render();
        this.focusExternalNameInput(focusTarget);
        return true;
    }

    public async removeExternalAttendee(index: number) {
        this.scheduleForm.externalAttendees.splice(index, 1);
        await this.service.render();
    }

    public async saveSchedule() {
        await this.addInternalAttendee(false);
        const externalAdded = await this.addExternalAttendee(false);
        if (!externalAdded) return;

        const title = this.readScheduleTitle();
        if (!title) {
            await this.service.modal.error('일정명을 입력해주세요.');
            return;
        }

        if (!this.scheduleForm.date) {
            await this.service.modal.error('예약 일자를 선택해주세요.');
            return;
        }

        if (!this.scheduleForm.roomId) {
            await this.service.modal.error('회의실을 선택해주세요.');
            return;
        }

        if (!this.scheduleForm.start || !this.scheduleForm.end) {
            await this.service.modal.error('예약 가능한 시간을 선택해주세요.');
            return;
        }

        if (this.scheduleForm.start >= this.scheduleForm.end) {
            await this.service.modal.error('종료 시간은 시작 시간 이후로 선택해주세요.');
            return;
        }

        if (this.hasScheduleConflict(this.scheduleForm.start, this.scheduleForm.end)) {
            await this.service.modal.error('선택한 회의실에 이미 예약된 시간입니다.');
            return;
        }

        if ((this.scheduleForm.externalAttendees || []).length > 0 && !this.scheduleForm.externalProjectName) {
            await this.service.modal.error('외부 참석자 프로젝트명을 입력해주세요.');
            return;
        }

        const roomName = this.roomName(this.scheduleForm.roomId);
        const organizerUser = this.currentUser();
        const event = {
            id: `new-${Date.now()}`,
            date: this.scheduleForm.date,
            roomId: this.scheduleForm.roomId,
            room: roomName,
            title,
            start: this.scheduleForm.start,
            end: this.scheduleForm.end,
            time: `${this.scheduleForm.start}-${this.scheduleForm.end}`,
            organizer: organizerUser.name,
            organizerUser,
            attendees: this.scheduleForm.attendees || [],
            externalProjectName: this.scheduleForm.externalProjectName || '',
            externalAttendees: (this.scheduleForm.externalAttendees || []).map((attendee: any) => {
                return {
                    ...attendee,
                    projectName: this.scheduleForm.externalProjectName || attendee.projectName || ''
                };
            }),
            memo: this.scheduleForm.memo || '',
            status: (this.scheduleForm.externalAttendees || []).length > 0 ? '외부' : '내부'
        };

        const response: any = await wiz.call("save", { data: JSON.stringify(event) });
        if (response.code !== 200) {
            const message = response.data?.message || response.message || '일정 추가에 실패했습니다.';
            await this.service.modal.error(message);
            return;
        }

        const savedEvent = response.data || event;
        this.events.push(savedEvent);
        this.showScheduleList = true;
        if (this.selectedRoom !== 'all' && this.selectedRoom !== savedEvent.roomId) {
            this.selectedRoom = savedEvent.roomId;
        }
        this.sortEvents();
        this.selectedDate = savedEvent.date;
        const selected = this.parseDateKey(savedEvent.date);
        this.currentYear = selected.getFullYear();
        this.currentMonth = selected.getMonth() + 1;
        this.showAddModal = false;
        this.buildCalendar();
        const failedCount = savedEvent.notification?.failed?.length || 0;
        if (failedCount > 0) {
            await this.service.modal.success(`일정이 추가되었습니다. 메일 ${failedCount}건은 발송되지 않았습니다.`);
        } else {
            await this.service.modal.success('일정이 추가되었습니다.');
        }
        await this.service.render();
    }

    public normalizeScheduleTime() {
        if (!this.scheduleForm) return;

        if (!this.scheduleForm.start || this.isStartDisabled(this.scheduleForm.start)) {
            this.scheduleForm.start = this.timeOptions.find((time: string) => !this.isStartDisabled(time)) || '';
        }

        if (!this.scheduleForm.end || this.isEndDisabled(this.scheduleForm.end)) {
            this.scheduleForm.end = this.timeOptions.find((time: string) => !this.isEndDisabled(time)) || '';
        }
    }

    public isStartDisabled(time: string) {
        if (!this.scheduleForm.date || !this.scheduleForm.roomId) return false;
        return !this.timeOptions.some((end: string) => {
            return end > time && !this.hasScheduleConflict(time, end);
        });
    }

    public isEndDisabled(time: string) {
        if (!this.scheduleForm.start) return true;
        if (time <= this.scheduleForm.start) return true;
        return this.hasScheduleConflict(this.scheduleForm.start, time);
    }

    private buildCalendar() {
        const firstDate = new Date(this.currentYear, this.currentMonth - 1, 1);
        const startOffset = firstDate.getDay();
        const daysInMonth = new Date(this.currentYear, this.currentMonth, 0).getDate();
        const totalCells = Math.ceil((startOffset + daysInMonth) / 7) * 7;
        const todayKey = this.toDateKey(new Date());
        const days = [];

        for (let index = 0; index < totalCells; index++) {
            const date = new Date(this.currentYear, this.currentMonth - 1, index - startOffset + 1);
            const dateKey = this.toDateKey(date);
            const events = this.eventsForDate(dateKey);

            days.push({
                iso: dateKey,
                day: date.getDate(),
                inMonth: date.getMonth() + 1 === this.currentMonth,
                isToday: dateKey === todayKey,
                isSelected: this.showScheduleList && dateKey === this.selectedDate,
                eventCount: events.length,
                visibleEvents: events.slice(0, 3),
                moreCount: Math.max(events.length - 3, 0)
            });
        }

        this.calendarDays = days;
    }

    private ensureSelectedDateInMonth() {
        if (!this.showScheduleList) return;

        const prefix = this.monthPrefix();
        if (this.selectedDate && this.selectedDate.startsWith(prefix)) return;

        const firstEvent = this.events.find((event: any) => {
            return event.date && event.date.startsWith(prefix) && this.matchesSelectedRoom(event);
        });
        this.selectedDate = firstEvent ? firstEvent.date : `${prefix}-01`;
    }

    private eventsForDate(dateKey: string) {
        return this.events.filter((event: any) => {
            return event.date === dateKey && this.matchesSelectedRoom(event);
        });
    }

    private matchesSelectedRoom(event: any) {
        return this.selectedRoom === 'all' || event.roomId === this.selectedRoom;
    }

    private hasScheduleConflict(start: string, end: string) {
        if (!this.scheduleForm.date || !this.scheduleForm.roomId || !start || !end) return false;

        return this.events.some((event: any) => {
            return event.date === this.scheduleForm.date
                && event.roomId === this.scheduleForm.roomId
                && start < event.end
                && end > event.start;
        });
    }

    private isEmail(email: string) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    private readScheduleTitle() {
        const modelTitle = (this.scheduleForm.title || '').trim();
        if (modelTitle) {
            this.scheduleForm.title = modelTitle;
            return modelTitle;
        }

        const input = document.getElementById('schedule-title') as HTMLInputElement | null;
        const domTitle = (input?.value || '').trim();
        if (domTitle) this.scheduleForm.title = domTitle;
        return domTitle;
    }

    private focusExternalNameInput(target: any) {
        if (typeof target === 'string') {
            target = document.getElementById(target);
        }
        if (!target || typeof target.focus !== 'function') return;
        setTimeout(() => target.focus(), 0);
    }

    private currentUser() {
        const session = this.service.auth.session || {};
        const email = session.email || '';
        return {
            id: session.id || '',
            name: session.name || email || '로그인 사용자',
            email,
            role: session.role || ''
        };
    }

    private ensureOrganizerMember() {
        const user = this.currentUser();
        if (!user.id) return;

        const exists = this.members.some((member: any) => String(member.id) === String(user.id));
        if (!exists) {
            this.members = [user, ...this.members];
        }
    }

    private withRoomStyles(rooms: any[]) {
        return rooms.map((room: any) => {
            const preset = this.rooms.find((item: any) => item.id === room.id) || {};
            return { ...preset, ...room };
        });
    }

    private sortEvents() {
        this.events = this.events.sort((left: any, right: any) => {
            const leftKey = `${left.date || ''} ${left.start || ''}`;
            const rightKey = `${right.date || ''} ${right.start || ''}`;
            return leftKey.localeCompare(rightKey);
        });
    }

    private monthPrefix() {
        return `${this.currentYear}-${String(this.currentMonth).padStart(2, '0')}`;
    }

    private parseDateKey(dateKey: string) {
        return new Date(`${dateKey}T00:00:00`);
    }

    private toDateKey(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private setDefaults() {
        this.rooms = [
            {
                id: '505-main',
                name: '505호 대표실',
                dotClass: 'bg-emerald-500',
                chipClass: 'border-emerald-200 bg-emerald-50 text-emerald-700',
                eventClass: 'border-l-emerald-500 bg-emerald-50 text-emerald-950 hover:bg-emerald-100'
            },
            {
                id: '505-meeting',
                name: '505호 회의실',
                dotClass: 'bg-sky-500',
                chipClass: 'border-sky-200 bg-sky-50 text-sky-700',
                eventClass: 'border-l-sky-500 bg-sky-50 text-sky-950 hover:bg-sky-100'
            },
            {
                id: '503-meeting',
                name: '503호 회의실',
                dotClass: 'bg-violet-500',
                chipClass: 'border-violet-200 bg-violet-50 text-violet-700',
                eventClass: 'border-l-violet-500 bg-violet-50 text-violet-950 hover:bg-violet-100'
            },
            {
                id: '503-seminar',
                name: '503호 세미나실',
                dotClass: 'bg-amber-500',
                chipClass: 'border-amber-200 bg-amber-50 text-amber-700',
                eventClass: 'border-l-amber-500 bg-amber-50 text-amber-950 hover:bg-amber-100'
            }
        ];

        this.events = [
            {
                id: 'evt-001',
                date: '2026-06-23',
                roomId: '505-main',
                room: '505호 대표실',
                title: '외부 미팅',
                start: '13:00',
                end: '14:00',
                time: '13:00-14:00',
                organizer: '정초롱',
                organizerUser: { id: 'demo-cho', name: '정초롱', email: 'chorong@kiosk.local' },
                attendees: [
                    { id: 'demo-sales', name: '김민수', email: 'sales@kiosk.local' }
                ],
                externalProjectName: 'Acme 리뉴얼',
                externalAttendees: [
                    { projectName: 'Acme 리뉴얼', name: '김하늘', email: 'haneul@example.com' }
                ],
                memo: '외부 방문 고객 응대',
                status: '외부'
            },
            {
                id: 'evt-002',
                date: '2026-06-23',
                roomId: '503-meeting',
                room: '503호 회의실',
                title: '내부 회의',
                start: '13:30',
                end: '14:30',
                time: '13:30-14:30',
                organizer: '운영팀',
                attendees: [
                    { id: 'demo-ops', name: '박지훈', email: 'ops@kiosk.local' }
                ],
                externalProjectName: '',
                externalAttendees: [],
                memo: '주간 운영 이슈 확인',
                status: '내부'
            },
            {
                id: 'evt-003',
                date: '2026-06-24',
                roomId: '503-seminar',
                room: '503호 세미나실',
                title: '제품 교육',
                start: '10:00',
                end: '11:30',
                time: '10:00-11:30',
                organizer: '교육팀',
                attendees: [
                    { id: 'demo-edu', name: '이서연', email: 'education@kiosk.local' }
                ],
                externalProjectName: '',
                externalAttendees: [],
                memo: '신규 기능 교육',
                status: '내부'
            },
            {
                id: 'evt-004',
                date: '2026-06-24',
                roomId: '505-meeting',
                room: '505호 회의실',
                title: '파트너 방문',
                start: '15:00',
                end: '16:00',
                time: '15:00-16:00',
                organizer: '영업팀',
                attendees: [
                    { id: 'demo-sales', name: '김민수', email: 'sales@kiosk.local' }
                ],
                externalProjectName: '파트너 운영',
                externalAttendees: [
                    { projectName: '파트너 운영', name: '이수진', email: '' }
                ],
                memo: '파트너사 미팅',
                status: '외부'
            },
            {
                id: 'evt-005',
                date: '2026-06-25',
                roomId: '503-meeting',
                room: '503호 회의실',
                title: '운영 점검',
                start: '09:30',
                end: '10:00',
                time: '09:30-10:00',
                organizer: '운영팀',
                attendees: [
                    { id: 'demo-ops', name: '박지훈', email: 'ops@kiosk.local' }
                ],
                externalProjectName: '',
                externalAttendees: [],
                memo: '키오스크 운영 상태 점검',
                status: '내부'
            },
            {
                id: 'evt-006',
                date: '2026-06-26',
                roomId: '505-main',
                room: '505호 대표실',
                title: '임원 보고',
                start: '11:00',
                end: '12:00',
                time: '11:00-12:00',
                organizer: '관리팀',
                attendees: [
                    { id: 'demo-admin', name: '관리자', email: 'admin@kiosk.local' }
                ],
                externalProjectName: '',
                externalAttendees: [],
                memo: '월간 현황 공유',
                status: '내부'
            },
            {
                id: 'evt-007',
                date: '2026-06-29',
                roomId: '505-meeting',
                room: '505호 회의실',
                title: '계약 검토',
                start: '14:00',
                end: '15:00',
                time: '14:00-15:00',
                organizer: '사업팀',
                attendees: [
                    { id: 'demo-biz', name: '이다은', email: 'business@kiosk.local' }
                ],
                externalProjectName: '신규 계약',
                externalAttendees: [
                    { projectName: '신규 계약', name: '장민호', email: 'minho@example.com' }
                ],
                memo: '신규 계약 조건 검토',
                status: '외부'
            },
            {
                id: 'evt-008',
                date: '2026-07-02',
                roomId: '503-seminar',
                room: '503호 세미나실',
                title: '신입 온보딩',
                start: '10:00',
                end: '12:00',
                time: '10:00-12:00',
                organizer: '인사팀',
                attendees: [
                    { id: 'demo-hr', name: '한유진', email: 'hr@kiosk.local' }
                ],
                externalProjectName: '',
                externalAttendees: [],
                memo: '신입 구성원 오리엔테이션',
                status: '내부'
            }
        ];

        this.members = [
            { id: 'demo-admin', name: '관리자', email: 'admin@kiosk.local', role: 'admin' },
            { id: 'demo-meeting', name: '회의실 담당자', email: 'meeting@kiosk.local', role: 'user' },
            { id: 'demo-ops', name: '박지훈', email: 'ops@kiosk.local', role: 'user' },
            { id: 'demo-sales', name: '김민수', email: 'sales@kiosk.local', role: 'user' },
            { id: 'demo-biz', name: '이다은', email: 'business@kiosk.local', role: 'user' },
            { id: 'demo-hr', name: '한유진', email: 'hr@kiosk.local', role: 'user' }
        ];
    }
}

export default PageCalendarComponent;